/* eslint-disable @typescript-eslint/no-explicit-any */
import { getServerSideHeaders } from '../../../../utils/api-headers'
import { capitalizeFirstLetter } from '../../../../utils/string'
import { getPriceData } from '../../common/price-info'
import { fetchProductsData } from './products-service'
import type { GroupedItem } from '../models'
import type { GetPLHeadDataReturnType } from '../../../../utils/prop-types'

export const getServerSideProps = async (props: Record<string, any>) => {
  const { config, general, groupBy } = props

  const res = await fetchProductsData({
    config,
    superTags: general?.superTags,
    groupBy,
    ...getServerSideHeaders()
  })
  return {
    ...props,
    initialData: { ...res?.data }
  }
}

export const getHeadData = async (
  props: Record<string, any>
): Promise<GetPLHeadDataReturnType> => {
  const { initialData, productRootPath, pageConfig } = props || {}

  const allowSubscriptionPrice = Boolean(pageConfig?.autoDeliveryPlp)

  const itemsList = initialData?.items as GroupedItem[]
  return {
    jsonLD: {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: itemsList?.map((item, index) => {
        const stock = item?.variants?.[0]?.stock?.stockLevelStatus ?? ''
        const pageUrl = productRootPath?.replace(
          '$SEO_URL_PLACEHOLDER',
          item?.variants?.[0]?.seo?.productsSeoUrl || ''
        )
        const { currentPrice } = getPriceData(
          item?.variants?.[0]?.price,
          allowSubscriptionPrice
        )
        return {
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Product',
            name: item?.variants?.[0]?.globalArticleName,
            image: item?.variants?.[0]?.assets?.[0]?.assetFullUrl,
            description: item?.variants?.[0]?.productShortDescription,
            sku: item?.variants?.[0]?.globalArticleCode,
            url: pageUrl,
            brand: {
              '@type': 'Brand',
              name: item?.variants?.[0]?.brand
            },
            offers: {
              '@type': 'Offer',
              url: pageUrl,
              priceCurrency: item?.variants?.[0]?.price?.priceCurrency,
              price: currentPrice,
              availability: `https://schema.org/${capitalizeFirstLetter(stock)}`
            }
          }
        }
      }),
      numberOfItems: itemsList?.length,
      itemListOrder: 'https://schema.org/ItemListOrderAscending'
    }
  }
}
